import React from 'react';
import VisitingClinicPage from './VisitingClinicPage';

const VisitingClinicHamilton = () => (
  <VisitingClinicPage
    seo={{
      title: 'Autism, ADHD & Learning Assessments Hamilton VIC | Clinical Minds Psychology',
      description: 'Full neurodevelopmental assessments at regular visiting clinics in Hamilton VIC: autism, ADHD, FASD and learning disorders, children to adults. First appointment by Zoom, then one visit covers both assessment days. Enquire about upcoming clinic dates.',
      canonicalUrl: 'https://www.clinicalminds.net/visiting-clinics/hamilton'
    }}
    location="Hamilton VIC"
    regionPhrase="the Western District and south-west Victoria"
    introExtra="Clinics run every two to three months."
  />
);

export default VisitingClinicHamilton;
